import React, { useEffect, useState } from "react";
import FormikControl from "../../../../components/FormikControls/FormikControl";
import {
  Box,
  Grid,
} from "@mui/material";
import { Formik, Form } from "formik";
// import { addIndexSchema } from "../../StaticData";
// import MultiSelect from "../../../../components/FormikControls/MultiSelect/MultiSelect";
import { useSelector } from "react-redux";
// import DySplitButton from "../../../../components/GlobalComponents/DySplitButton/DySplitButton";
// import AccordionLyt from "../../../../components/Layouts/AccordionLyt/AccordionLyt";
// import { addIndexFace } from "../../Interfaces/Interfaces";
import DYToastMessage from "../../../../components/GlobalComponents/DyToastMessage/DYToastMessage";

// import { useGetAllActivePersonByTenantId } from "../../Hooks";
// import { CircularProgress } from "@mui/material";
// import DyLoadingCircular from "../../../../components/GlobalComponents/DyLoadingCircular/DyLoadingCircular";
// import { useGetPriodById } from "../../../../components/Login/Hooks/Index";
import DyButton from "../../../../components/GlobalComponents/DyButton/DyButton";
// import MultiSel from "../../../../components/MultiSel/MultiSel";
// import VerticalAlignments from "../../new/verticalAlignments";
// import { ArrowDropDownIcon } from "@mui/x-date-pickers";
// import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { useEditCategory} from "../../../IndexBank/Hooks/Index";
// import CustomeMultiSelect from "../../new/customeMultiSelect";
import { ErrorMessage } from "formik";
import "../../../CompanyManagment/Forms/RegisterTenant/Error.css";
// interface teamIdsFace {
//   teamId: string;
//   personIds: string[];
// }
// allIds

const EditCategory = ({
  onSuccess,
  setShowToastMessage,
  setObjectiveAsyncOpState,
  afterSuccess,
  krDetail,
  onClose
}: any) => {
  const teId: string = useSelector(
    (state: any) => state.meetings.profileTenantId
  );
  const [showAdvanceOptions, setShowAdvanceOptions] = useState<boolean>(false);
  const{name,id,tenantId} : any = krDetail  || {};
  const [isSucces, SetIsSuccess] = useState<boolean>();
  const [tMessage, SetTMessage] = useState<string>();
  // const [showAdvanceOptions, setShowAdvanceOptions] = useState<boolean>(false);
  // const [periodId, setLocalPeriosId] = useState<string>(periodId);
  const [showVerticalAlignment, setShowVerticalAlignment] =
    useState<boolean>(false);
  const [showMultiSelect, setShowMultiSelect] = useState<boolean>(false);
  const [objNameIds, setObjNameIds] = useState<any>({
    tenantId: teId,
    // periodId: periodId,
    definitionLevelId: null,
  });

  // const { data: teamsOptions, isLoading: teamOPloading } =
  //   useGetAllObjectiveDefinitionLevelByTenantId(tenantId);
  //const { data: categoriesOptionds ,isLoading:getActivePersonLoading} = useGetAllCategoriesTenantId(tenantId);
  const {
    mutate: addObjective,
    data: addObjectiveData,
    isSuccess,
    isLoading,
    isError: isErrorInAddObjective,
  } = useEditCategory();


  const [showLtoastMessage, setShowLtoastMessage] = useState<any>(null);

  useEffect(() => {
    if (addObjectiveData) {
      if (addObjectiveData?.data.isSuccess) {
        // setSuccessAddObjective(isSuccess)
        setShowToastMessage(true);
        SetIsSuccess(true);
        SetTMessage(addObjectiveData?.data.metaData.message);
        // onSuccess();
        onClose(false);
      } else {
        setShowLtoastMessage(true);
        SetIsSuccess(false);
        SetTMessage(addObjectiveData?.data.metaData.message);
      }
    }
  }, [addObjectiveData]);

  const addObjectiveInitialValues: any = {
    name: name,
    id:id,
    // createById:'',
    // description: "",
    // indexType2: "lag",
    // indexType1: "KPI",
    // AddToMyList : true,
    // AddToTenantList : true,
    tenantId:tenantId
    // isPublic: true,
    // keyResultParentIds: [],
    // responsibleId: "",
    // allIds: [],
    // tenantId: "",
    // weight: null,
    // answerRequest: "",
  };

  const initialAddObjective = async (data: any) => {
    // let { isPublic } = data;
//    await addObjective({...data,tenantId:tenantId});
   await addObjective({...data});
  };


  return (
    <>
      <Box width={"100%"} maxHeight={"50em"}>
        <Formik
          enableReinitialize
          //validationSchema={addIndexSchema}
          validate={(data) => {
            let { definitionLevelId, responsibleId, isPublic }: any = data;
            // console.log(isPublic)
            // setTeameIdObjects((prev:teamIdsFace)=>({...prev,personIds:[responsibleId]}))
            // setHorzIds((prev:any)=>({...prev,definitionId:definitionLevelId}))
            // console.log(data)
          }}
          initialValues={addObjectiveInitialValues}
          onSubmit={(data) => {
            initialAddObjective(data);
          }}
        >
          {({
            values,
            setFieldValue,
            dirty,
            isValid,
            touched,
            errors,
            setFieldTouched,
            handleChange,
          }: any) => (
            <Form>
              <Grid container>
                <Grid item xs={12} md={12}>
                  <FormikControl
                    control="textField"
                    type="text"
                    label="شرح"
                    name="name"
                    fullWidth
                    values={values?.name || ""}
                  />
                </Grid>

                <Grid item xs={12} md={12} mt={3}>
                  <Box
                    width={"100%"}
                    display={"flex"}
                    justifyContent={"end"}
                    flexDirection={"row-reverse"}
                    columnGap={2}
                  >
                      <Box width={"20%"}>
                            <DyButton
                              disabled={false}
                              // key={i}
                              variant={"contained"}
                              bgColor={"info"}
                              caption={'ثبت'}
                              type={"submit"}
                              onClick={() => { }}
                            />
                          </Box>
                  </Box>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>

        {showLtoastMessage && (
          <DYToastMessage
            isSuccess={isSucces}
            message={tMessage}
            setShow={setShowLtoastMessage}
            show={showLtoastMessage}
          />
        )}
      </Box>
    </>
  );
};

export default EditCategory;